/**
 * This file has all the types and interfaces needed for Scenario action and reducers
 */

import { ResetStateAction } from "components/curb/ManagerAnalyzer/Toggle/commonUtilities";
import {
    DefaultScenarios,
    Scenario
} from "../../components/curb/ManagerAnalyzer/Manager/SelectScenarios/helpers";
import { GetRequestWithoutLimitOffset } from "../../interfaces/ActionReducer/GetMethod/GetRequestWithoutLimitOffset";

export const GET_SCENARIOS = "GET_SCENARIOS";
export const SCENARIOS_RECEIVED = "SCENARIOS_RECEIVED";
export const SCENARIO_SELECTED = "SCENARIO_SELECTED";
export const SET_DEFAULT_SCENARIOS = "SET_DEFAULT_SCENARIOS";
export const POST_NEW_SCENARIO = "POST_NEW_SCENARIO";
export const UPDATE_SCENARIO = "UPDATE_SCENARIO";
export const SET_HISTORICAL_SCENARIO = "SET_HISTORICAL_SCENARIO";
export const DELETE_SCENARIO = "DELETE_SCENARIO";
export const CLEAR_SELECTED_SCENARIO = "CLEAR_SELECTED_SCENARIO";

export interface PostNewScenarioPayload {
    name: string;
    workorder_id?: number;
    project_id: number;
    afterProcess?: (newScenario: Scenario) => void;
}
export interface GetScenariosAction {
    type: typeof GET_SCENARIOS;
    payload: { params: GetRequestWithoutLimitOffset };
}

export interface ScenariosReceivedAction {
    type: typeof SCENARIOS_RECEIVED;
    payload: { data: Scenario[] };
}

export interface ScenarioSelectedAction {
    type: typeof SCENARIO_SELECTED;
    payload: { selectedScenario: Scenario | null };
}

export interface ScenariosStateInterface {
    scenarios: Scenario[] | null;
    selectedScenario: Scenario | null;
    defaultScenarios: DefaultScenarios | null;
    historicalSelectedScenario: Scenario | null;
    isFetchingScenarios: boolean;
}

export interface SetDefaultScenariosAction {
    type: typeof SET_DEFAULT_SCENARIOS;
    payload: { defaultScenarios: DefaultScenarios };
}

export interface PostNewScenarioAction {
    type: typeof POST_NEW_SCENARIO;
    payload: PostNewScenarioPayload;
}

export interface UpdateScenarioAction {
    type: typeof UPDATE_SCENARIO;
    payload: { scenario_id: number; name: string; afterProcess?: () => void };
}

export interface SetHistoricalSelectedScenarioAction {
    type: typeof SET_HISTORICAL_SCENARIO;
    payload: { selectedScenario: Scenario };
}
export interface DeleteScenarioAction {
    type: typeof DELETE_SCENARIO;
    payload: { scenarioId: (number | undefined)[]; afterProcess?: () => void };
}

export interface ClearSelectedScenarioAction {
    type: typeof CLEAR_SELECTED_SCENARIO;
}

export type ScenariosState = ScenariosStateInterface;
export type ScenarioId = number | undefined;

export type ScenariosActionsType =
    | GetScenariosAction
    | ScenariosReceivedAction
    | ScenarioSelectedAction
    | SetDefaultScenariosAction
    | PostNewScenarioAction
    | UpdateScenarioAction
    | SetHistoricalSelectedScenarioAction
    | DeleteScenarioAction
    | ResetStateAction;
